import styled from "styled-components";
export const StyledDropdownValue = styled.span `
  background: none;
  border: 1px solid transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10};
  outline: none;
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.black};
  width: auto;
  padding-left: 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 2.5rem;
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }

  span {
    box-sizing: border-box;
    height: 2.5rem;
  }

  @media ${({ theme }) => theme.device.touch} {
    span {
      height: 2.75rem;
    }
  }

  @media (hover: hover) {
    :hover {
      cursor: pointer;
      background: rgb(${({ theme }) => theme.colors.transparentBlack}, 0.04);
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey14};
    }
  }

  :focus {
    ${({ focused, theme }) => focused
    ? `
    border: 1px solid ${theme.colors.primaryLight};
    outline: 1px solid ${theme.colors.primaryLight};
    `
    : ""}
  }

  :active {
    ${({ theme }) => theme.global.disableTapHighlight}

    background: rgb(${({ theme }) => theme.colors.transparentBlack}, 0.06);
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey14};
  }
`;
export const Title = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
export const Wrapper = styled.div `
  position: relative;
  div {
    position: absolute;
    z-index: 99;
    width: 100%;
    top: calc(100% + 1px);
    background-color: ${({ theme }) => theme.colors.white};
  }
`;
